import { opIsMemberSession, opMemberUserId } from './config.js';

export function opModal() {
    return $('#addOpenPaymentModal');
}

export function openPaymentSelectedUserId() {
    const prefilled = opMemberUserId();
    if (prefilled) {
        return String(prefilled);
    }
    return String(opModal().find('#open_payment_user_id').val() || '').trim();
}

export function openPaymentHasMemberSelected() {
    const uid = parseInt(openPaymentSelectedUserId(), 10);
    return Number.isFinite(uid) && uid > 0;
}

export function openPaymentCardChoiceValue() {
    return String(opModal().find('#open_payment_payment_type').val() || '');
}

export function openPaymentIsOnline() {
    if (opIsMemberSession()) {
        return true;
    }
    return opModal().find('input[name="open_payment_method"]:checked').val() === 'online';
}
